import { dateTransformer } from '@/common/utils/dateTransformer'
import { formatCurrency } from '@/common/utils/formatters'
import { getFilenameFromUrl } from '@/common/utils/getFilenameFromUrl'
import { CompanyPriceSurveyValidationSchema } from '@/features/privateCompanies/schemas/priceSurvey/create.schema'
import { CompanyPriceSurveyData } from '@/features/privateCompanies/types/companyPriceSurvey.type'

export const companyPriceSurveyDefaultValues: (props?: CompanyPriceSurveyData) => CompanyPriceSurveyValidationSchema = (
  companyPriceSurvey,
) => ({
  survey_conducted_at: companyPriceSurvey?.survey_conducted_at
    ? dateTransformer(companyPriceSurvey.survey_conducted_at)
    : '',
  geo_geoables_attributes:
    companyPriceSurvey?.geo_geoables?.map(({ geo }) => ({
      label: geo.display_name,
      value: geo.id,
      type: 'Geo::City',
    })) || [],
  price_survey_products_attributes:
    companyPriceSurvey?.price_survey_products?.map(({ id, product, price }) => ({
      id,
      product_id: product.id,
      display_name: product.display_name,
      price: formatCurrency(Number(price) || 0),
    })) || [],
  evidences_attachments_attributes:
    companyPriceSurvey?.evidences?.map((attachment) => ({
      id: attachment.id,
      fileName: getFilenameFromUrl(attachment?.url),
      currentFileUrl: attachment?.url,
    })) || [],
})
